import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';


import {
  getLocalizedDate
} from 'shared/utils/Utils';

import {
  formatCurrency,
  renderPurchaseDescription
} from 'shared/services/PriceService';

import {
  getSelectedCalculations
} from 'shared/selectors/cartSelectors';


const styles = () => ({
  header: {
    fontSize: '1.3rem',
    fontWeight: 700,
    textAlign: 'left',
    fontFamily: config.root_font_family
  },
  purchaseDetails: {
    width: '100%',
    textAlign: 'left',
    fontSize: '0.9rem',
    marginBottom: '1rem',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    fontFamily: config.root_font_family,
    color: config.pwa_default_font_color + ' !important'
  },
  purchaseDetailsCol: {
    padding: '0.5rem 0',
    color: config.pwa_default_font_color + ' !important'
  },
  purchaseDetailsAmountCol: {
    width: '40%',
    textAlign: 'right',
    padding: '0.5rem 0',
    color: config.pwa_default_font_color + ' !important'
  },
  p: {
    width: '100%',
    textAlign: 'left',
    marginTop: '0.5rem !important',
    marginBottom: '0.5rem !important',
    fontSize: '0.9rem',
    fontFamily: config.root_font_family
  },
  div: {
    padding: '0.5rem 0'
  },
  ul: {
    listStyleType: 'square',
    padding: '0 0 0 1rem'
  }
});

class PurchaseDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  renderPurchaseComplete() {
    const { classes, purchases, locale } = this.props;

    if (!purchases.length) {
      return null;
    }

    let total = 0;
    let rows = [];

    let getLine = purchase => {
      const {
        quantity,
        print_count,
        unlock_all_applied,
        created_at
      } = purchase;

      let description = renderPurchaseDescription(quantity, print_count, unlock_all_applied, false);
      let noWrap = { whiteSpace: 'nowrap' };
      let timestamp = <FormattedMessage {...withValues(messages.cart_on_date, { date: getLocalizedDate(locale, created_at) })} />;

      return <span>{description} <span style={noWrap}>{timestamp}</span></span>;
    }

    for (let purchase of purchases) {
      total += purchase.total;

      let line = getLine(purchase);
      let amount = (
        <span>{formatCurrency(purchase.total, purchase.stripe_currency, true)}</span>
      );

      rows.push((
        <tr>
          <td className={classes.purchaseDetailsCol}>
            {line}
          </td>
          <td className={classes.purchaseDetailsAmountCol}>
            {amount}
          </td>
        </tr>
      ));
    }

    let currency = purchases[0].stripe_currency;
    let totalFormatted = formatCurrency(total, currency, true);

    let purchaseDetails = (
      <div>
        <table className={`table ${classes.purchaseDetails}`}>
          {rows}
          <tr>
            <td className={classes.purchaseDetailsCol}>
              <b>
                <FormattedMessage {...messages.cart_total} />
              </b>
            </td>
            <td className={classes.purchaseDetailsAmountCol}>
              <b>{totalFormatted}</b>
            </td>
          </tr>
        </table>
      </div>
    );

    let header = null;
    if (!this.props.hideHeader) {
      header = (
        <p className={classes.header}>
          <FormattedMessage {...messages.kiosk_order_details_header} />
        </p>
      );
    }

    return (
      <div>
        {header}
        {purchaseDetails}
      </div>
    );
  }

  render() {
    const { user } = this.props;

    if (!user) {
      return null;
    }

    return this.renderPurchaseComplete();

  }
}

const mapStateToProps = state => ({
  user: state.userReducer.user,
  purchases: state.cartReducer.purchases,
  currency: state.cartReducer.calculations.currency,
  locale: state.messagesReducer.locale,
});

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(PurchaseDetails));
